import { IconButton } from 'components/IconButton/IconButton'
import { ArrowRight } from 'almanac-ui/icons'
import { useStepper } from 'components/AIRevision/Stepper/StepperProvder'

export const ForwardButton = () => {
  const { stepForward, step, steps } = useStepper()
  const onLastStep = step >= steps
  return (
    <IconButton
      isDisabled={onLastStep}
      icon={ArrowRight}
      size="sm"
      variant="tertiary"
      aria-label="Next"
      onPress={stepForward}
    />
  )
}
